import {
  Input,
  Component,
  OnInit,
  forwardRef,
  ElementRef,
  ViewChild,
  HostListener,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription, Subject, Observable, Observer } from 'rxjs';
import { HttpClient } from '@angular/common/http';
declare var $: any;

export const TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TextAreaComponent),
  multi: true,
};

@Component({
  selector: '[textAreaInput]',
  templateUrl: 'textarea.component.html',
  providers: [TEXTAREA_VALUE_ACCESSOR],
})
export class TextAreaComponent implements ControlValueAccessor, OnInit {
  @Input() divClass: string;
  @Input() labelInput: string;
  @Input() valueTextArea: string;
  @Input() mandatory: boolean;
  @Input() showPlaceholder: boolean = true;
  @Input() maxlength: number;
  @ViewChild('dtextarea') el: ElementRef;

  @Input() disabled: boolean = false;

  _value: string;
  _current: boolean;
  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};
  randomId: string = this.getRandomId();

  @Input() submitPending: boolean;
  public enableObservable: Observable<boolean>;
  private subscription: Subscription = null;
  private enableObserver: Observer<boolean>;
  
  constructor(private httpService: HttpClient, private elementRef: ElementRef) {}

  private createServiceSubscription() {
    this.enableObservable = new Observable<boolean>((observer) => {
      this.enableObserver = observer;
      if (this.enableObserver) {
        this.submitPending = true;
      } else {
        this.submitPending = false;
      }
    });
  }

  ngOnInit(): void {
    if (!this.submitPending) {
      this.createServiceSubscription();
    }
  }

  modelChanged(): any {
    this.onChangeCallback(
      this._value ? this._value.split('\\').join('/') : undefined
    );
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  getRandomId(length: number = 10): string {
    return crypto.randomUUID();
  }

  selectAll(event: FocusEvent): void {
    const target = event.target as HTMLTextAreaElement;
    target.select();
  }
}
